<script setup>

import {computed} from "vue";
import {usePortalContentAndDesignStore} from "../../../../../../stores/partners/portalContentAndDesignStore";
import FormErrors from "../../Errors/FormErrors.vue";
import {useSubAccountLogin} from "../../../../../../composables/partners/useSubAccountLogin";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const { submitLogin } = useSubAccountLogin();

const forgotPasswordRoute = computed(() => {
    return portalContentAndDesignStore.isPreview ? '#' : route('partners.sub_account.password.request.show');
});
</script>

<template>
    <div id="sub-account-login-form" style="display: block;">
        <div class="mb-6 space-y-4">

            <form-errors :store-form-errors="portalContentAndDesignStore.loginFormErrors"/>

            <div>
                <editable-text-field
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_email"
                    for-attribute="email"
                    class="block text-sm opacity-80 mb-1.5"
                    :class="portalContentAndDesignStore.getPageContentTextColorClass"
                    text-type="label"
                >
                </editable-text-field>
                <input
                    type="email"
                    name="email"
                    id="email"
                    v-model="portalContentAndDesignStore.loginFormData.email"
                    :required="true"
                    :class="portalContentAndDesignStore.getInputStyle"
                >
            </div>

            <div>
                <editable-text-field
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_password"
                    for-attribute="password"
                    :class="[
                        'block text-sm opacity-80 mb-1.5',
                        portalContentAndDesignStore.getPageContentTextColorClass
                    ]"
                    text-type="label"
                >
                </editable-text-field>

                <input
                    type="password"
                    name="password"
                    id="password"
                    v-model="portalContentAndDesignStore.loginFormData.password"
                    :required="true"
                    :class="portalContentAndDesignStore.getInputStyle"
                    @keyup.enter="submitLogin"
                >
            </div>
        </div>
        <div class="flex items-center justify-between my-6">
            <div class="space-x-2 flex text-sm">
                <input type="checkbox"
                       name="remember"
                       id="remember"
                       :class="portalContentAndDesignStore.getCheckboxInputStyle"
                >
                <editable-text-field
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_remember_me"
                    for-attribute="remember"
                    :class="[
                        'text-sm',
                        portalContentAndDesignStore.getPageContentTextColorClass
                    ]"
                    text-type="label"
                >
                </editable-text-field>
            </div>
            <div class="text-sm">
                <editable-text-field
                    text-type="a"
                    :href="forgotPasswordRoute"
                    :class="[
                        'hover:underline text-opacity-100',
                        portalContentAndDesignStore.getLinkColorClass
                     ]"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_forgot_password"
                >
                </editable-text-field>
            </div>
        </div>
    </div>
</template>

